<template>
    <modal name="send-gift" @before-open="beforeOpen" @before-close="beforeClose"
        :classes="['v--modal', 'modal', 'send-gift']" :width="730" :height="'auto'" :scrollable="true" :adaptive="true">
        <div class="modal-title">
            {{ $t("myFriends.sendGift") }}
        </div>
        <div class="modal-close" @click="close"></div>
        <div v-if="pageLoader" class="modal-body">
            {{ $t("loading.loading") }}
        </div>
        <div v-else class="modal-body">
            <div class="send-gift-image">
                <img :src="gift.image" alt="" class="send-gift-img">
            </div>
            <div class="checkbox-group">
                <input v-model="anonymous" type="checkbox" id="anonymous" class="input-checkbox">
                <label for="anonymous" class="checkbox-label">
                    {{ $t("sendGift.anonymousGift") }}
                </label>
            </div>
            <div class="form-item">
                <textarea v-model="message" name="message" :placeholder="$t('sendGift.messageGift')" :maxlength="140"
                    class="textarea"></textarea>
            </div>
            <div class="modal-buy-summary">
                <div v-if="formatPrice(gift.cost) != 0">
                    <div class="modal-buy-total">
                        {{ formatPrice(gift.cost) }}
                        {{ declineNouns(
                            formatPrice(gift.cost),
                            [
                                $t("photoDetails.zarik"),
                                $t("photoDetails.zarika"),
                                $t("photoDetails.zarikov")
                            ]
                        ) }}
                    </div>
                    <div v-if="parseFloat(user.balance) < parseFloat(formatPrice(gift.cost))" class="modal-buy-balance">
                        <span class="text-warning">
                            {{ $t("roulette.notEnoughFunds") }},
                        </span>
                        <span @click="$modal.show('balance-in')" class="link-underlined">
                            {{ $t("roulette.refill") }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-footer buttons-row">
                <button @click="close" class="button-secondary">
                    {{ $t("stories.cancel") }}
                </button>
                <button v-if="buttonLoader" class="button button-loader"></button>
                <button v-else @click="send" :disabled="parseFloat(user.balance) < parseFloat(formatPrice(gift.cost))"
                    class="button">
                    {{ $t("stories.continue") }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { declineNouns } from '@/mixins/declineNouns';
import { checkScroll } from '@/mixins/checkScroll';

export default {
    name: 'SendGift',
    props: {
        i18n: Object,
    },
    mixins: [
        declineNouns,
        checkScroll
    ],
    data() {
        return {
            pageLoader: true,
            buttonLoader: false,
            gift: {},
            userId: '',
            image: '',
            message: '',
            anonymous: false,
            // price: 30
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/fetchUser',
            init: 'init/fetchInit',
        })
    },
    methods: {
        beforeOpen(event) {
            this.checkScroll();
            this.message = '';
            this.gift = event.params.gift;
            this.userId = event.params.userId;
            this.pageLoader = false;
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        send() {
            this.buttonLoader = true;
            let data = {
                gift: this.gift.id,
                message: this.message,
                anonymous: this.anonymous,
                to_user: this.userId
            };
            this.$store.dispatch('gifts/sendGift', data)
                .then(() => {
                    this.buttonLoader = false;
                    this.$modal.show('dialog', {
                        title: this.$t("albumEdit.success"),
                        text: this.$t("sendGift.giftSent"),
                        buttons: [
                            {
                                title: this.$t("albumEdit.ok")
                            }
                        ]
                    });
                    this.$modal.hide('send-gift');
                    this.$modal.hide('gifts-list');
                })
                .catch(() => {
                    this.buttonLoader = false;
                });
        },
        formatPrice(price) {
            if (this.user.vip && this.gift.id >= 7) {
                return Math.ceil(
                    price *
                    (100 - this.init.costs.vip_discount) /
                    100
                );
            }
            let arr = price.split('.');
            return arr[1] == '00' ? arr[0] : price;
        },
        close() {
            this.$modal.hide('send-gift');
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/components/_validation';
</style>

<style lang="scss">
@import '~@/assets/styles/layout/_send-gift';
</style>
